(function () {
  var swiperCallbacks = window.__swiperCbs || [];
  var swiperLoading = false;
  var alpineLoading = false;

  window.__swiperCbs = swiperCallbacks;

  function yieldToMain(fn) {
    if (typeof scheduler !== 'undefined' && typeof scheduler.yield === 'function') {
      scheduler.yield().then(fn);
      return;
    }
    setTimeout(fn, 0);
  }

  function runSwiperCallbacks() {
    var queue = swiperCallbacks.slice();
    swiperCallbacks.length = 0;
    function next() {
      if (!queue.length) {
        document.dispatchEvent(new Event('swiper:ready'));
        return;
      }
      var cb = queue.shift();
      try {
        cb();
      } catch (e) {}
      yieldToMain(next);
    }
    yieldToMain(next);
  }

  window.whenSwiperReady = function (cb) {
    if (typeof Swiper !== 'undefined') {
      yieldToMain(cb);
      return;
    }
    swiperCallbacks.push(cb);
  };

  function loadSwiper() {
    if (typeof Swiper !== 'undefined') {
      runSwiperCallbacks();
      return;
    }
    if (swiperLoading) return;
    var src = window.ELLITEE_SWIPER_SRC;
    if (!src) return;
    swiperLoading = true;
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = runSwiperCallbacks;
    document.head.appendChild(s);
  }

  function loadAlpine() {
    if (window.Alpine || alpineLoading || !window.ELLITEE_ALPINE_SRC) return;
    alpineLoading = true;
    var s = document.createElement('script');
    s.src = window.ELLITEE_ALPINE_SRC;
    s.defer = true;
    document.body.appendChild(s);
  }

  function watchSwipers() {
    var nodes = document.querySelectorAll('.swiper');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      loadSwiper();
      return;
    }
    var io = new IntersectionObserver(
      function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          obs.disconnect();
          loadSwiper();
          return;
        }
      },
      { rootMargin: '160px 0px', threshold: 0 }
    );
    nodes.forEach(function (node) {
      io.observe(node);
    });
  }

  function bindAlpineIntent() {
    var events = ['pointerdown', 'keydown', 'touchstart'];
    function onIntent() {
      events.forEach(function (name) {
        window.removeEventListener(name, onIntent, true);
      });
      loadAlpine();
    }
    events.forEach(function (name) {
      window.addEventListener(name, onIntent, { capture: true, passive: true });
    });
  }

  function idle(fn, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: timeout || 2500 });
    } else {
      setTimeout(fn, timeout || 1);
    }
  }

  function start() {
    bindAlpineIntent();
    idle(loadAlpine, 6000);
    requestAnimationFrame(function () {
      idle(watchSwipers, 1500);
    });
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
